import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { css, styled } from 'styled-components';
import { Box } from "../../box/src";
import { createFontsTheme, focusOutline, primaryShadow, responsive, ThemeProvider, thickenPrimaryShadow, } from "../../theme/src";
export const Card = styled(Box)
    .withConfig({
    shouldForwardProp: (prop) => ![
        'cursor',
        'canBeHovered',
        'isFocused',
        'noBorderRadiusOnSmallScreen',
    ].includes(prop),
})
    .attrs(({ children, p, pb, pl, pr, pt, px, py, theme }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const fonts = useMemo(() => createFontsTheme({
        themeVariables: Object.assign(Object.assign({}, theme.themeVariables), { fontBrightness: theme.themeVariables.frameFontBrightness }),
    }), [theme.themeVariables]);
    const updatedTheme = useMemo(() => (Object.assign(Object.assign({}, theme), { fonts, themeVariables: Object.assign(Object.assign({}, theme.themeVariables), { fontBrightness: theme.themeVariables.frameFontBrightness }) })), [fonts, theme]);
    return {
        bg: theme.themeVariables.frameBackgroundColor,
        children: _jsx(ThemeProvider, { theme: updatedTheme, children: children }),
        display: 'block',
        pb: (_b = (_a = p !== null && p !== void 0 ? p : py) !== null && _a !== void 0 ? _a : pb) !== null && _b !== void 0 ? _b : { _: 4, m: 6 },
        pl: (_d = (_c = p !== null && p !== void 0 ? p : px) !== null && _c !== void 0 ? _c : pl) !== null && _d !== void 0 ? _d : { _: 4, m: 6 },
        pr: (_f = (_e = p !== null && p !== void 0 ? p : px) !== null && _e !== void 0 ? _e : pr) !== null && _f !== void 0 ? _f : { _: 4, m: 6 },
        pt: (_h = (_g = p !== null && p !== void 0 ? p : py) !== null && _g !== void 0 ? _g : pt) !== null && _h !== void 0 ? _h : { _: 4, m: 6 },
    };
}) `
  ${primaryShadow}

  ${(props) => props.canBeHovered &&
    !props.isFocused &&
    css `
      &:hover {
        ${thickenPrimaryShadow}
      }
    `}
  ${(props) => props.cursor &&
    css `
      cursor: ${props.cursor};
    `}
  ${(props) => Boolean(props.onKeyPress) &&
    css `
      ${focusOutline}
    `}
  ${({ isFocused, theme }) => isFocused &&
    css `
      box-shadow: ${theme.focusOutline.boxShadow};
      z-index: 1;
    `}
  /* Theme Variables */
  ${(props) => props.noBorderRadiusOnSmallScreen
    ? css `
          border-radius: 0px;
          ${responsive('m') `
        border-radius: ${({ theme }) => theme.themeVariables.globalBorderRadius}px;
      `}
        `
    : css `
          border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
        `}
`;
//# sourceMappingURL=Card.js.map